import classNames from 'classnames'
import DropdownImage from './DropdownImage'

interface DropdownItemProps {
  title: string
  value?: string
  customClass?: string
  href?: string
  variant?: string
  image?: string
  onClick?: JSX.MouseEventHandler
  key?: string
}

const DropdownItem = (props: DropdownItemProps) => {
  const { customClass, href, onClick, title, variant, value, image, key } = props
  const classes = classNames(
    variant ? 'control-dropdown__item--' + variant : '',
    image ? 'control-dropdown__item--with_image' : '',
    customClass
  )

  return (
    <a
      className={classes}
      href={href}
      onClick={onClick}
      value={value}
      data-value={title}
      key={key}
    >
      {image && <DropdownImage image={image} />}
      {title}
    </a>
  )
}

export default DropdownItem
